<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="700" scrollable>
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>BÁO CÁO ĐIỂM DANH</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <v-data-table
            dense
            item-key="id"
            disableSort
            :items-per-page="10"
            :headers="headers"
            :items="data"
            hide-default-footer
          >
            <template v-slot:[`item.student`]="{ item }">
              <CardStudentName :student="item.student" link />
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <div>
                <v-chip
                  class="ml-10 white--text"
                  :color="item.status === 'present' ? 'green' : item.status === 'absent' ? 'orange' : 'gray'"
                  >{{ getStatusData('', item.status) }}</v-chip
                >
                <v-chip
                  v-if="item.subStatus !== 'none'"
                  class="ml-10 white--text"
                  :color="item.subStatus === 'onTime' || item.subStatus === 'excused' ? 'green' : 'orange'"
                  >{{ getDataSubStatus('', item.subStatus) }}</v-chip
                >
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider />
        <v-card-actions class="d-flex ">
          <v-spacer />
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="cancel">Đóng</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getStatusData } from '@/modules/classNote/teacherSide/class-attendance/headers.js'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
export default {
  components: {
    CardStudentName
  },
  data() {
    return {
      dialog: false,
      data: [],
      headers: [
        { text: 'Học sinh', value: 'student' },
        { text: 'Trạng thái điểm danh', value: 'status', align: 'center' }
      ]
    }
  },
  methods: {
    openDialog(data) {
      this.data = data
      this.dialog = true
    },
    cancel() {
      this.dialog = false
    },
    getDataSubStatus(type = '', status) {
      switch (status) {
        case 'onTime':
          if (type === 'color') return 'color: green'
          return 'Đúng giờ'
        case 'lateTime':
          if (type === 'color') return 'color: orange'
          return 'Vào muộn'
        case 'excused':
          if (type === 'color') return 'color: green'
          return 'Có phép'
        case 'unexcused':
          if (type === 'color') return 'color: orange'
          return 'Không phép'
        default:
          return ''
      }
    },
    getStatusData: getStatusData
  }
}
</script>
